export const getFaIconFromExt = ext => {
    let icon;
    switch (ext) {
        // Simple text (.txt) files
        case 'txt':
            icon = `faFileText`;
            break;
        // Csv files
        case 'csv':
            icon = `faFileCsv`;
            break;
        // Audio files
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'flac':
        case 'aac':
        case 'm4a':
        case 'wma':
        case 'aiff':
        case 'opus':
            icon = `faFileAudio`;
            break;
        // Video Files
        case 'mp4':
        case 'mov':
        case 'avi':
        case 'mkv':
        case 'webm':
        case 'wmv':
        case 'flv':
        case 'm4v':
        case '3gp':
            icon = `faFileVideo`;
            break;
        // PDF
        case 'pdf':
            icon = `faFilePdf`;
            break;
        // MS Word Docs
        case 'doc':
        case 'docx':
            icon = `faFileWord`;
            break;
        // Excel
        case 'xls':
        case 'xlsx':
            icon = `faFileExcel`;
            break;
        // PowerPoint (ppt, pptx, pps, etc.)
        case 'ppt':
        case 'pptx':
        case 'pps':
        case 'ppsx':
        case 'pot':
        case 'potx':
            icon = `faFilePowerpoint`;
            break;
        // Compressed files
        case 'zip':
        case 'rar':
            icon = `faFileZipper`;
            break;
        default:
            icon = `faFile`;
    }

    return icon;
};
